const RoutingList = ({ Component }) => {
  // Optional: auth check, animation, layout styling
  return <Component />;
};

export default RoutingList;
